import React, { useEffect, useState } from "react";
import { Button, Modal, Row, Table, Tooltip } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../..";
import { ReactComponent as DeleteIcon } from "../../img/delete.svg";
import { ResponsibleUserSelectModal } from "../AccountCreate/ResponsibleUser/ResponsibleUserSelectModal";
import { AccountCreateActiveModal } from "../AccountCreate/types/AccountCreateActiveModal";
import { useActiveModal } from "../../lib/utils";
import { createManager, deleteManager } from "../../store/slices/links";
import { fetchAllUsers, fetchResponsibleUsers } from "../../store/slices/accountsTs";
import { User } from "../../lib/interfaces/User";
import { fetchAccountById } from "../../store/slices/accounts";

interface TableRecord {
  key: string;
  id: number;
  lastName: string;
  firstName: string;
  middleName: string;
  email: string;
}

export const AccountResponsibleUserTable = () => {
  const dispatch = useAppDispatch();
  const accountId = useParams();
  const { responsibleUsers } = useAppSelector((state) => state.accountsTs);
  const { account } = useAppSelector((state) => state.accounts);
  const [tableData, setTableData] = useState<TableRecord[]>([]);

  const {
    activeModal,
    setActiveModal,
    activeModalOptions,
  } = useActiveModal<AccountCreateActiveModal>("");

  useEffect(() => {
    if (activeModal === "responsibleSelect") {
      dispatch(fetchAllUsers({}));
    }
  }, [activeModal]);

  useEffect(() => {
    // const properties = account.organization.contactIndividual.map((item) => item.properties).flat();
    // const position = properties.find(({ typeId }) => typeId === "position");
    // const positionName = position?.stringValue
    //   ?.split("")
    //   .map((item, i) => (i > 0 ? item : item.toUpperCase()));

    setTableData(
      responsibleUsers.map((user) => ({
        key: String(user.id),
        id: user.id,
        lastName: user.userInfo.lastName,
        firstName: user.userInfo.firstName,
        middleName: user.userInfo.middleName,
        email: user.userInfo.email,
      }))
    );
  }, [responsibleUsers]);

  const columnsWidths = {
    lastName: "15%",
    firstName: "17%",
    middleName: "17%",
    email: "",
    actions: "90px",
  };

  const columns = [
    {
      title: "Фамилия",
      dataIndex: "lastName",
      key: "lastName",
      width: columnsWidths.lastName,
    },
    {
      title: "Имя",
      dataIndex: "firstName",
      key: "firstName",
      width: columnsWidths.firstName,
    },
    {
      title: "Отчество",
      dataIndex: "middleName",
      key: "middleName",
      width: columnsWidths.middleName,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: columnsWidths.email,
    },
    {
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      render: (value, record) => {
        const onClick = () => {
          setActiveModal("responsibleDelete", record?.id);
        };
        return (
          <Tooltip title="Отвязать менеджера">
            <DeleteIcon style={{ cursor: "pointer", marginLeft: "8px" }} onClick={onClick} />
          </Tooltip>
        );
      },
    },
  ];

  const updateResponsibleUsers = () => {
    // @ts-ignore
    dispatch(fetchAccountById({ id: accountId?.accountId }));
  };

  const handleCreateManager = (user: User) => {
    const bodyParams = {
      fromId: account?.organization?.id,
    };
    const _bodyParams = { ...bodyParams, toId: user.id };
    dispatch(
      createManager({
        params: {
          linkTypeAlias: "account_auth_user",
        },
        dataPost: _bodyParams,
      })
    ).then(() => {
      updateResponsibleUsers();
    });
    setActiveModal("");
  };

  const handleDeleteManager = () => {
    dispatch(
      deleteManager({
        linkTypeAlias: "account_auth_user ",
        fromId: account?.organization?.id,
        toId: Number(activeModalOptions),
      })
    ).then(() => {
      updateResponsibleUsers();
    });
    setActiveModal("");
  };

  return (
    <>
      <Row align="middle" style={{ marginTop: "50px" }}>
        <h4 style={{ margin: "0 0" }}>Менеджеры B2O</h4>
        <Tooltip title="Добавить менеджера">
          <Button
            style={{ color: "#00BB77", marginLeft: "15px", border: "none" }}
            shape="circle"
            icon={<PlusCircleFilled />}
            onClick={() => setActiveModal("responsibleSelect")}
          />
        </Tooltip>
      </Row>

      <Table columns={columns} dataSource={tableData} pagination={false} />
      <ResponsibleUserSelectModal
        visible={activeModal === "responsibleSelect"}
        setActiveModal={setActiveModal}
        onSubmit={handleCreateManager}
        responsibleUserFormData={tableData}
      />
      <Modal
        title={<h3 style={{ color: "#58647C" }}>Менеджеры B2O</h3>}
        footer={[
          <Button key="1" onClick={() => setActiveModal("")}>
            Отмена
          </Button>,
          <Button key="2" onClick={handleDeleteManager} type="primary">
            Отвязать
          </Button>,
        ]}
        visible={activeModal === "responsibleDelete"}
        onCancel={() => setActiveModal("")}
      >
        Вы действительно хотите отвязать выбранного менеджера от оператора?
      </Modal>
    </>
  );
};
